import {
  AsyncActionState,
  asyncActionStateMatchers,
  invoke,
  setupSlice,
} from '@owl-frontend/redux';
import type { Artifact } from '../../api/artifacts/interface';
import {
  fetchClaimArtifacts,
  fetchDossierClaims,
} from '../../api/policyClaims/client';
import type { PolicyClaim } from '../../api/policyClaims/interface';

export interface PolicyClaimsState {
  byDossierId: {
    [dossier_id: string]: PolicyClaim[];
  };
  claimsStatusByDossierId: {
    [dossier_id: string]: string;
  };
  artifactsByClaimId: {
    [claim_id: string]: Artifact[];
  };
  artifactsStatusByClaimId: {
    [claim_id: string]: string;
  };
  actions: {
    fetchClaims: AsyncActionState<PolicyClaim[]>;
    fetchClaimArtifacts: AsyncActionState<Artifact[]>;
  };
}

const initialState: PolicyClaimsState = {
  byDossierId: {},
  claimsStatusByDossierId: {},
  artifactsByClaimId: {},
  artifactsStatusByClaimId: {},
  actions: {
    fetchClaims: { status: 'uninitialized' },
    fetchClaimArtifacts: { status: 'uninitialized' },
  },
};

const slice = setupSlice('policyClaims', initialState)
  .addAsyncSagas({
    fetchClaims: invoke(fetchDossierClaims),
    fetchClaimArtifacts: invoke(fetchClaimArtifacts),
  })
  .addReducers({
    'fetchClaims/pending': (state, action) => {
      state.claimsStatusByDossierId[action.meta.arg] = 'pending';
    },
    'fetchClaims/fulfilled': (state, action) => {
      state.byDossierId[action.meta.arg] = action.payload;
      state.claimsStatusByDossierId[action.meta.arg] = 'fulfilled';
    },
    'fetchClaims/rejected': (state, action) => {
      state.claimsStatusByDossierId[action.meta.arg] = 'rejected';
    },
    'fetchClaimArtifacts/pending': (state, action) => {
      state.artifactsStatusByClaimId[action.meta.arg] = 'pending';
    },
    'fetchClaimArtifacts/fulfilled': (state, action) => {
      state.artifactsByClaimId[action.meta.arg] = action.payload;
      state.artifactsStatusByClaimId[action.meta.arg] = 'fulfilled';
    },
    'fetchClaimArtifacts/rejected': (state, action) => {
      state.artifactsStatusByClaimId[action.meta.arg] = 'rejected';
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
